module.exports = __webpack_public_path__ + "static/media/warningAlert.b7714e87.svg";